"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarrierPaymentType = exports.CarrierAccountStatus = exports.Carrier = void 0;
var Carrier;
(function (Carrier) {
    Carrier["UPS"] = "UPS";
    Carrier["FEDEX"] = "FEDEX";
})(Carrier || (exports.Carrier = Carrier = {}));
var CarrierAccountStatus;
(function (CarrierAccountStatus) {
    CarrierAccountStatus["ACTIVE"] = "ACTIVE";
    CarrierAccountStatus["INACTIVE"] = "INACTIVE";
})(CarrierAccountStatus || (exports.CarrierAccountStatus = CarrierAccountStatus = {}));
var CarrierPaymentType;
(function (CarrierPaymentType) {
    CarrierPaymentType["THIRD_PARTY"] = "THIRD_PARTY";
    CarrierPaymentType["RECEIVER"] = "RECEIVER";
    CarrierPaymentType["COLLECT"] = "COLLECT";
})(CarrierPaymentType || (exports.CarrierPaymentType = CarrierPaymentType = {}));
//# sourceMappingURL=CarrierAccount.js.map